import React from 'react';
import {
  IonPage, IonContent,
} from '@ionic/react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './NoGoals.css';
import appStrings from '../common/app_strings';
import CardAtom from '../common/atoms/card/CardAtom';
import appColors from '../common/app_colors';

const { goals: { noGoals } } = appStrings;
const { cards, text } = appColors;

const NoGoals = () => (
  <IonPage>
    <Header />
    <IonContent fullscreen>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="no-goals-container"
      >
        <div className="no-goals-decoration-wrapper">
          <img
            alt=""
            src="/assets/light-blue-circle-dark-blue-accent.svg"
            style={{ paddingLeft: '3rem' }}
          />
        </div>
        <Typography
          variant="h1"
          sx={{
            color: text.darkNavy,
            fontSize: 28,
            fontWeight: 700,
            maxWidth: '18ch',
            textAlign: 'center',
            mt: 6,
            mb: 8,
            mx: 'auto',
          }}
        >
          {noGoals.title}
        </Typography>
        <Box mx={3} mb={4}>
          <CardAtom
            img="/assets/big-little-blue-triangle.svg"
            header={noGoals.cardTitle}
            body={noGoals.cardBody}
            containerStyles={{
              bgcolor: cards.secondaryBackground,
            }}
            headerStyles={{ color: text.darkNavy }}
            bodyStyles={{ color: text.lightBlack, fontSize: 13 }}
            imgStyles={{ maxWidth: '85px', paddingTop: '16px' }}
            showArrow
          />
        </Box>
      </motion.div>
    </IonContent>
    <Footer />
  </IonPage>
);

export default NoGoals;
